import CmgHeaderActionsRight from '../components/CmgHeader/CmgHeaderActionsRight/CmgHeaderActionsRight.vue';
import CmgCountryFlag from '@/components/CmgCountryFlag/CmgCountryFlag.vue';
import CmgHeaderHamburgerIcon from '@/components/CmgHeader/CmgHeaderHamburgerIcon/CmgHeaderHamburgerIcon.vue';
import axios from 'axios';

export interface AemIdComponent {
  id: string;
  component: any;
}

const AEMComponents: AemIdComponent[] = [
  // { id: '#aem-header-user-icon', component: CmgHeaderUserIcon },
  { id: '#aem-header-actions-right', component: CmgHeaderActionsRight },
  // { id: '#aem-header-find-a-chipotle', component: CmgHeaderFindAChipotle },
  { id: '#aem-header-hamburger-icon', component: CmgHeaderHamburgerIcon },
  // { id: '#aem-favorites-recents', component: CmgRecentAndFavoriteOrdersMini },
  // { id: '#aem-featured-meals', component: CmgFeatured },
  { id: '#aem-country-modal', component: CmgCountryFlag }
];

const AEMIds = AEMComponents.map(n => n.id);

const AEMHomepageIds = ['#aem-xf-hero', '#aem-xf-tout', '#aem-xf-crowd-pleasers'];
const AEMHomepageXfs = [
  {
    id: 'aem-xf-hero',
    url: '/content/experience-fragments/chipotle/us/en/xf-homepage-hero/master.html',
    rootSelector: '.hero',
    cb: function (html: HTMLElement) {
      const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const updatedElement = mutation.target as HTMLElement;
            if (updatedElement.classList.contains('aem-home')) {
              const placeholder = updatedElement.querySelector('.aem-home > .noo-hero-goes-here');
              if (placeholder) {
                placeholder.insertAdjacentElement('afterbegin', html);
                setTimeout(() => {
                  if (window.CHIPW && window.CHIPW.ui && window.CHIPW.ui.lazyloadVideo) {
                    console.log('Attempting to load hero video');
                    window.CHIPW.ui.lazyloadVideo(document.querySelector('.hero video'));
                  }
                }, 500);
              } else {
                console.warn('Failed to load AEM XF Hero on homepage');
                location.reload();
              }
            }
          }
        }
      });

      insertHero(document.documentElement, html);

      // Start observing the document for changes
      observer.observe(document.documentElement, { childList: true });
    },
  },
];

// Dynamically request XF's
async function getAemXfHtml(url: string, rootSelector: string, cb: (html: HTMLElement) => void) {
  try {
    const res = await axios.get(url);
    if (res && res.data) {
      const xf = new DOMParser().parseFromString(res.data, 'text/html');
      const html = rootSelector ? xf.querySelector(rootSelector) : xf;
      if (html) {
        cb(html as HTMLElement);
      } else {
        console.warn('Failed to find root selector in fetched HTML');
      }
    }
  } catch (err) {
    console.log('Error fetching AEM XF', err);
  }
}

function insertHero(targetElement: HTMLElement, html: HTMLElement) {
  const placeholder = targetElement.querySelector('.home > .noo-hero-goes-here');
  if (placeholder) {
    placeholder.insertAdjacentElement('afterbegin', html);
    setTimeout(() => {
      if (window.CHIPW && window.CHIPW.ui && window.CHIPW.ui.lazyloadVideo) {
        console.log('Attempting to load hero video');
        window.CHIPW.ui.lazyloadVideo(document.querySelector('.hero video'));
      }
    }, 500);
  } else {
    console.warn('Failed to load AEM XF Hero on homepage');
  }

  document.querySelectorAll('.aem-hero__button').forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const buttonHref = button.getAttribute('href')!.substring(1);
      const topLevelMenu = document.getElementById(buttonHref);
      if (topLevelMenu) {
        topLevelMenu.scrollIntoView();
        history.pushState(null, '', `#${buttonHref}`);
      } 
    });
  });
}

export { AEMComponents, AEMIds, AEMHomepageIds, AEMHomepageXfs, getAemXfHtml }